import { render, staticRenderFns } from "./AddClientsModal.vue?vue&type=template&id=4327d95c&scoped=true&"
import script from "./AddClientsModal.vue?vue&type=script&lang=js&"
export * from "./AddClientsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddClientsModal.vue?vue&type=style&index=0&id=4327d95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327d95c",
  null
  
)

export default component.exports